<template>
  <div>
    <div class="row menubar tabs">
      <button @click="$store.state.currentView='Intakes'">Onboarding</button>
      <button @click="$store.state.currentView='IntakesRedos'">Her-intakes</button>
      <button class="active">Afgeronde intakes</button>
      <button @click="$store.state.currentView='IntakesDeleted'">Geannuleerde intakes</button>
    </div>

    <tableFilter
      name="intakesCompletedFilters"
      ref="filterComp"
      :activeAmount="activeFilters"
      :mainFunction="getIntakes"
      v-model="filters"
    />

    <div class="card" v-if="intakes !== null && intakes.length">
      <table width=100%>
        <thead class="table-legend">
          <tr>
            <th># / Port</th>
            <th>E-mail</th>
            <th>Sinds / Afgerond</th>
            <th></th>
          </tr>
        </thead>
        <tr
          v-for="intake in intakes"
          :key="intake.id"
        >
          <td>
            {{intake.id}}
            <br>
            <span v-if="intake.port">[{{intake.port}}]</span>
            <span v-else class="grey">-</span>
            <br>
          </td>
          <td>
            {{intake.email}}
            <br>
            <span v-if="intake.redo">Herintake!</span>
          </td>
          <td>
            <span class="grey">{{(new Date(intake.date)).toLocaleDateString()}}</span><br>
            <span class="grey">{{(new Date(intake.complete_date)).toLocaleDateString()}}</span><br>
          </td>
          <td>
            <button
              class="secondary" style="float:right;padding:5px;" title="Bekijken"
              @click="doAction('view', intake)"
            >
              <awesomeIcon icon="search"/>
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalIntakes"
        :resultsPerPage="maxPerPage"
      />
    </div>

    <div v-else-if="intakes !== null && !intakes.length" class="noresults">
      <span>Geen resultaten</span>
    </div>

    <div v-else class="loader" />
  </div>
</template>

<script>
export default {
  name: 'IntakesRedos',
  data() {
    return {
      intakes: null,
      currentPage: 0,
      role: this.$store.state.role,
      maxPerPage: 20,
      activeFilters: [],
      filters: [
        {
          name: 'generalInput',
          model: '',
          cookie: 'intakesCompletedGeneralInput',
          filterName: 'search',
          operator: 'contains',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
          title: 'ID, Port, E-mail adres',
        },
        {
          name: 'idInput',
          label: 'ID',
          type: 'number',
          cookie: 'intakesCompletedIdInput',
          model: '',
          filterName: 'id',
          operator: 'eq',
          operators: ['eq', 'neq'],
        },
        {
          name: 'portInput',
          label: 'Portefeuille',
          type: 'string',
          cookie: 'intakesCompletedPortInput',
          model: '',
          filterName: 'port',
          operator: 'eq',
          operators: ['eq', 'neq', 'startswith', 'endswith'],
        },
        {
          name: 'userIdInput',
          label: 'Gebruiker',
          type: 'user',
          cookie: 'intakesCompletedUserIdInput',
          model: '',
          filterName: 'client',
          operator: 'eq',
          operators: ['eq', 'neq'],
        },
        {
          name: 'minDateSince',
          label: 'Sinds vanaf',
          type: 'date',
          model: '',
          cookie: 'completedIntakesSinceMinDateInput',
          filterName: 'sincedate',
          operator: 'eqgt',
          operators: ['eqgt', 'gt'],
          attributes: [
            {
              name: 'max',
              value: this.updateDateLimits('minmax'),
            },
          ],
        },
        {
          name: 'maxDateSince',
          label: 'Sinds tot',
          type: 'date',
          model: '',
          cookie: 'completedIntakesSinceMaxDateInput',
          filterName: 'sincedate',
          operator: 'eqlt',
          operators: ['eqlt', 'lt'],
          attributes: [
            {
              name: 'min',
              value: this.updateDateLimits('maxmin'),
            },
            {
              name: 'max',
              value: this.updateDateLimits('maxmax'),
            },
          ],
        },
        {
          name: 'minDateCompleted',
          label: 'Afgerond vanaf',
          type: 'date',
          model: '',
          cookie: 'completedIntakesCompletedMinDateInput',
          filterName: 'completedate',
          operator: 'eqgt',
          operators: ['eqgt', 'gt'],
          attributes: [
            {
              name: 'max',
              value: this.updateDateLimits('minmax'),
            },
          ],
        },
        {
          name: 'maxDateCompleted',
          label: 'Afgerond tot',
          type: 'date',
          model: '',
          cookie: 'completedIntakesCompletedMaxDateInput',
          filterName: 'completedate',
          operator: 'eqlt',
          operators: ['eqlt', 'lt'],
          attributes: [
            {
              name: 'min',
              value: this.updateDateLimits('maxmin'),
            },
            {
              name: 'max',
              value: this.updateDateLimits('maxmax'),
            },
          ],
        },
        {
          name: 'completedIntakesRedoInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'completedIntakesRedoInput',
          operator: 'in',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Alles',
                  value: 'Alles',
                },
                {
                  label: 'Her-intake',
                  value: 'Her-intake',
                },
                {
                  label: 'Intake',
                  value: 'Intake',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'Alles',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.$refs.filterComp.get();
    },
  },
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() < 9
        ? '0' : ''}${date.getMonth() + 1}-${date.getDate() < 10 ? '0'
        : ''}${date.getDate()}`;
    },
    doAction(action, intake) {
      if (action === 'view') {
        window.open(`?intake=${intake.id}`);
      }
    },
    updateDateLimits(type) {
      if (type === 'minmax') {
        if (this.maxDateFilter) {
          if (new Date(this.maxDateFilter).getDate() === new Date().getDate()) {
            const newDate = new Date(this.maxDateFilter);
            newDate.setDate(newDate.getDate() - 1);
            return this.formatDate(newDate);
          }
          return this.formatDate(new Date(this.maxDateFilter));
        }
        return this.formatDate(new Date());
      }
      if (type === 'maxmin' && this.minDateFilter) {
        return this.formatDate(new Date(this.minDateFilter));
      }
      if (type === 'maxmax') {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1);
        return this.formatDate(currentDate);
      }
      return '';
    },
    getIntakes(newSearch, filter = '', activeFilters = []) {
      this.intakes = null;
      this.activeFilters = activeFilters;

      const redoStatus = this.$refs.filterComp.getValue('completedIntakesRedoInput');

      if (redoStatus) {
        this.createCookie('completedIntakesRedoInput', redoStatus);
      } else {
        this.eraseCookie('completedIntakesRedoInput');
      }
      if (redoStatus === 'Her-intake') {
        filter.push('redo eq 1');
      }

      if (redoStatus === 'Intake') {
        filter.push('redo neq 1');
      }

      if (this.activeFilters.length) {
        this.$refs.filterComp.toggle(true);
      }

      if (filter.length) {
        filter = filter.join(';');
      }

      if (newSearch) {
        this.currentPage = 0;
      }

      this.sdk.getAdminIntakeCompleted((response) => {
        if (response.status === 200) {
          this.intakes = response.data.results;
          this.totalIntakes = response.data.totalRows;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage);
    },
  },
};
</script>
<style lang="scss" scoped>
.menubar {
  button {
    border-radius: 0;
  }
  .dropdown-button {
    float: left;
    margin-right: 2px;
  }
}
span {
  float: none !important;
}
.noresults {
  width: 100%;
  height: auto;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
  }
}
</style>
